angular.module("avant.customer_applications.directives").directive "bindBgImage", ->
  (scope, element, attrs) ->
    attrs.$observe "bindBgImage", (value) ->
      element.css
        "background-image": "url(" + value + ")"
        "background-size": "cover"